<template>
  <div class="add-insect" :style="style"></div>
</template>

<script>
export default {
  props: {
    data: Object
  },
  computed: {
    style() {
      const { width, height, left, top } = this.data
      return `width: ${width}px;height:${height}px;left:${left}px;top:${top}px;`
    }
  }
}
</script>

<style lang="css" scoped>
.add-insect {
  position: absolute;
  background-color: rgba(0, 128, 255, 0.3);
  pointer-events: none;
}
</style>
